// ============================================================================
// CECODEV Platform - Auth Validation Schemas
// ============================================================================
import { z } from "zod";
// --------------------------------------------------------------------------
// Login: étape 1 — email + mot de passe
// --------------------------------------------------------------------------
export const loginSchema = z.object({
    email: z.email("Email invalide"),
    password: z.string().min(6, "Le mot de passe doit contenir au moins 6 caractères"),
});
// --------------------------------------------------------------------------
// Login: étape 2 — vérification code 2FA
// --------------------------------------------------------------------------
export const verify2FASchema = z.object({
    userId: z.string().uuid("userId invalide"),
    code: z.string().length(6, "Le code doit contenir 6 chiffres"),
    trustDevice: z.boolean().optional().default(true),
});
// --------------------------------------------------------------------------
// Inscription INTER (nouveau compte)
// --------------------------------------------------------------------------
export const registerSchema = z.object({
    email: z.email("Email invalide"),
    password: z.string().min(8, "Le mot de passe doit contenir au moins 8 caractères"),
    prenom: z.string().min(1, "Le prénom est requis"),
    nom: z.string().min(1, "Le nom est requis"),
    telephone: z.string().optional(),
    // ALUMNI_CECODEV (2026-08-18) : l'ancien de Cecodev entre par SON parcours —
    // participant de l'org `cecodev`, actif d'emblée, e-learning / vidéos /
    // groupes d'entraînement. Il candidatera ENSUITE pour animer en Inter.
    // ANIMATEUR_INTER reste ACCEPTÉ (clients en cache) mais n'est plus une voie
    // d'entrée : il est traité comme ALUMNI_CECODEV côté serveur.
    typeInscription: z.enum(["PARTICIPANT_INTER", "ALUMNI_CECODEV", "ANIMATEUR_INTER"]),
});
// --------------------------------------------------------------------------
// Création compte INTRA (par pilote)
// --------------------------------------------------------------------------
export const createIntraUserSchema = z.object({
    email: z.email("Email invalide"),
    prenom: z.string().min(1, "Le prénom est requis"),
    nom: z.string().min(1, "Le nom est requis"),
    telephone: z.string().optional(),
    role: z.enum(["ANIMATEUR", "PARTICIPANT"]),
});
// --------------------------------------------------------------------------
// Mot de passe oublié
// --------------------------------------------------------------------------
export const forgotPasswordSchema = z.object({
    email: z.string().email("Email invalide"),
});
// --------------------------------------------------------------------------
// Reset / définition mot de passe (token)
// --------------------------------------------------------------------------
export const resetPasswordSchema = z.object({
    token: z.string().min(1, "Token requis"),
    password: z.string().min(8, "Le mot de passe doit contenir au moins 8 caractères"),
});
// --------------------------------------------------------------------------
// Changement mot de passe (connecté)
// --------------------------------------------------------------------------
export const changePasswordSchema = z.object({
    currentPassword: z.string().min(1, "Le mot de passe actuel est requis"),
    newPassword: z.string().min(8, "Le nouveau mot de passe doit contenir au moins 8 caractères"),
    confirmPassword: z.string(),
}).refine((data) => data.newPassword === data.confirmPassword, {
    message: "Les mots de passe ne correspondent pas",
    path: ["confirmPassword"],
});
//# sourceMappingURL=auth.js.map